import ScrollPane from "../../../../../lib/html5-software-library/src/ranj/components/scrolling/ScrollPane";
import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import Rectangle from "../../../../../lib/html5-software-library/src/ranj/geom/Rectangle";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AssetLoadService from "../../../core/assetloading/AssetLoadService";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import NGTVariableManager from "../../base/NGTVariableManager";
import FileAssetLocator from "../controller/FileAssetLocator";

export default class FileViewerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {FileAssetLocator} fileAssetLocator 
     * @param {AssetLibrary} assetLibrary 
     * @param {AssetLoadService} assetLoadService 
     * @param {RevisableLanguagePack} languagePack 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, fileAssetLocator, assetLibrary, assetLoadService, languagePack, variableManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._fileAssetLocator = fileAssetLocator;
        this._assetLibrary = assetLibrary;
        this._assetLoadService = assetLoadService;
        this._languagePack = languagePack;
        this._variableManager = variableManager;

        this._file = this.getCustomData().file;
    }

    initialize() {
        super.initialize();

        // Set a variable marking the file as viewed so that we can act upon it in the story
        this._variableManager.setVariable(`file_${this._file.getFileID()}_viewed`, true);


        this._loadingIndicator = this._target.loadingIndicator;
        this._loadingIndicator.spinner.snapToPixel = false; // makes rotating animation smoother
        this._loadingIndicator.spinner.gotoAndPlay(0);
        this._loadingIndicator.loadingTextField.text = this._languagePack.getText(`fileExplorer.loadingText`);
        this._loadingIndicator.alpha = 0;

        this._itemContainer = this._target.scrollPane.itemContainer;

        const halvedDragButtonHeight = this._target.scrollBar.dragButton.nominalBounds.height * .5;
        const scrollPaneBounds = this._target.scrollPane.nominalBounds;
        const viewport = new Rectangle(0, 0, scrollPaneBounds.width, scrollPaneBounds.height);
        this._scrollPane = new ScrollPane(viewport, null, this._target.scrollBar, this._target.scrollPane.itemContainer, null, true, true, halvedDragButtonHeight);

        this._target.title.text = this._file.getName();

        // click eater so that the player cannot click another file item through this screen
        this._target.scrollPane.addEventListener('click', () => {});

        this._showFile();
    }

    _showFile() {
        const url = this._fileAssetLocator.getFileLocationById(this._file);
        const content = this._file.getContent();
        const type = content.getType();
        switch (type) {
            case ContentTypes.TYPE_IMAGE:
                this._loadAndShowImage(content.getImage(), url);
                break;
        }
    }

    _loadAndShowImage(id, url) {
        this._showLoadingIndicator();
        this._assetLoadService.lazyLoadImage(id, url, this._onImageLoaded.bind(this));
    }

    _onImageLoaded(assetId) {
        this._hideLoadingIndicator();

        const image = this._assetLibrary.getAsset(assetId);
        const bitmap = new createjs.Bitmap(image);
        this._itemContainer.addChild(bitmap);

        this._updateScrollPane();
    }

    _showLoadingIndicator() {
        createjs.Tween.get(this._loadingIndicator, { override: true })
            .to({ alpha: 1 }, 650, createjs.Ease.sineInOut);
    }

    _hideLoadingIndicator() {
        createjs.Tween.removeTweens(this._loadingIndicator);
        this._loadingIndicator.alpha = 0;
    }

    _updateScrollPane() {
        const contentBounds = this._itemContainer.getBounds();
        let contentHeight = contentBounds ? contentBounds.height : 0;
        this._scrollPane.setHeightBound(contentHeight);
        this._scrollPane.setScrollPosition(0, 0);
    }
}